import React, { useContext } from 'react';
import {
	useCurrentLanguage,
	useTranslationHelpBlog,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { useHelpBlogBreadcrumbs } from '@dealstack/frontend/app/pages/HelpBlog/useHelpBlogBreadcrumbs.tsx';
import { HelpBlogLayout } from '@dealstack/frontend/app/pages/HelpBlog/HelpBlogLayout/HelpBlogLayout.tsx';
import { Flex, Text, Title } from '@mantine/core';
import { FullscreenLoader } from '@dealstack/frontend/shared/components/loaders/FullLoaderScreenLoader/FullLoaderScreenLoader.tsx';
import { QuickSwitchBreadcrumbsNav } from '@dealstack/frontend/shared/components/QuickSwitchBreadcrumbsNav/QuickSwitchBreadcrumbsNav.tsx';
import { useAuthors } from '@dealstack/frontend/app/pages/HelpBlog/api/useAuthors.ts';
import { AuthorsPageContainer } from '@dealstack/frontend/app/pages/HelpBlog/AuthorsPage/AuthorsPage.styles.tsx';
import { HelpBlogContext } from '@dealstack/frontend/app/pages/HelpBlog/useHelpBlogController.tsx';
import { HELP_BLOG_ROUTES } from '@dealstack/frontend/shared/shared-routes.ts';

export const AuthorsPage = () => {
	const { dataset, perspective } = useContext(HelpBlogContext);
	const tHelpBlog = useTranslationHelpBlog();
	const currentLanguage = useCurrentLanguage();
	const navigate = useNavigate();
	const { authors, isFetching } = useAuthors(dataset, currentLanguage, perspective);

	useHelpBlogBreadcrumbs([
		{
			name: tHelpBlog('breadcrumbs.help-title'),
			url: ROUTES.HELP_BLOG,
		},
		{
			name: tHelpBlog('breadcrumbs.help.authors'),
			url: `/${HELP_BLOG_ROUTES.AUTHORS}`,
			noLink: true,
		},
	]);

	if (isFetching) {
		return <FullscreenLoader name="pageLoading" />;
	}

	return (
		<HelpBlogLayout>
			<AuthorsPageContainer>
				<div className="container">
					<div className="breadcrumbs">
						<QuickSwitchBreadcrumbsNav showQuickSwitch={false} />
					</div>

					<div className="header">
						<Title size="h1" fw={600} className="title">
							{tHelpBlog('authors.title')}
						</Title>

						<Text className="meta-text">
							{authors.length}{' '}
							{authors.length > 1
								? tHelpBlog('authors.count_plural')
								: tHelpBlog('authors.count')}
						</Text>
					</div>

					<Flex gap="1rem">
						{authors.map((author) => {
							return (
								<div
									className="author"
									key={author.id}
									onClick={() => navigate(author.slug.current)}
								>
									<Title size="h4" className="author-title" fw={600}>
										{author.name}
									</Title>
									<Text fz="lg" className="author-position">
										{author.position}
									</Text>
									<Text fz="sm" className="author-posts">
										{author.postsCount}{' '}
										{author.postsCount > 1
											? tHelpBlog('authors.post_count_plural')
											: tHelpBlog('authors.posts_count')}
									</Text>
								</div>
							);
						})}
					</Flex>
				</div>
			</AuthorsPageContainer>
		</HelpBlogLayout>
	);
};
